<script type="ts">
    import { onMount } from "svelte";
    import type SceneManager from "../scene-manager";
    import { launchStage } from "./stage";
    import RotateClockwise32 from "carbon-icons-svelte/lib/RotateClockwise32";
    import RotateCounterclockwise32 from "carbon-icons-svelte/lib/RotateCounterclockwise32";
    import TrashCan32 from "carbon-icons-svelte/lib/TrashCan32";
    import Locked32 from "carbon-icons-svelte/lib/Locked32";
    import Unlocked32 from "carbon-icons-svelte/lib/Unlocked32";
    import { Button, ButtonSet } from "carbon-components-svelte";
    import { SceneManagerEvent } from "../scene-manager";
    import { stores } from "@nubolab-ffwd/svelte-fluent/src/internal/FluentProvider.svelte";
    import { getLocalizedValue } from '../helpers';

    const { getTranslation } = stores();

    let langCode = $getTranslation("language-code").value;

    export let manager: SceneManager;

    let renderTarget;
    let locked = false;
    let hideTools = true;
    let multiple = false;

    onMount(() => {
        launchStage(renderTarget, manager, langCode);
    })

    manager.addListener(SceneManagerEvent.Select, ({items}) => {
        hideTools = !items?.length || items.some(i => i.type === "Pannel_100x250");
        
        if(!hideTools) {
            multiple = items?.length > 1;
            locked = items.some(i => i.locked);
        } else {
            multiple = false;
            locked = false;
        }
    });

    function toggleItemLock(e) {
        e.stopPropagation();
        const lck = !locked;
        manager.selectedItems.forEach((selected) => {
            manager.putItem({
                ...selected,
                locked: lck,
            });
        });
        locked = lck;
    }

</script>

<div class="scene" bind:this={renderTarget}>
    <div class="tools" class:tools--hide={hideTools}>
        <ButtonSet>
            <Button id="rotateLeftButton" icon={RotateClockwise32} iconDescription="Rechts drehen" disabled={multiple || locked} />
            <Button id="rotateRightButton" icon={RotateCounterclockwise32} iconDescription="Links drehen" disabled={multiple || locked} />
            <Button id="deleteButton" icon={TrashCan32} iconDescription="Löschen" />
            <Button icon={locked ? Locked32 : Unlocked32} iconDescription={locked ? "Lösen" : "Fixieren"} on:click={toggleItemLock} />
        </ButtonSet>
    </div>
</div>

<style type="text/scss">
    .scene {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
    }
    .tools {
        position: absolute;
        left: 50%;
        bottom: 3rem;
        transition: all .3s ease-in;
        opacity: 1;
        transform: translateX(-50%);
        visibility: visible;


        &--hide {
            transform: translateX(-50%) translateY(50%);
            transition: all .3s ease-out;
            opacity: 0;
            visibility: hidden;
        }

        :global(.bx--btn) {
            flex-shrink: 1;
        }
    }
</style>